import request from "@/utils/request";

async function exchangeProductDetailApi(loginUserId, areaId, productId) {
    return new Promise((resolve) => {
        // 模拟API调用，实际应用中应该用uni.request等API进行网络请求
        setTimeout(async () => {
            await request.get('/productDetail/lessMoney', {
                params: {
                    userId: loginUserId,
                    areaId: areaId,
                    productId: productId
                }
            })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log("exchangeProductDetailApi error:" + error);
                });
        }, 1000);
    });

}

export {exchangeProductDetailApi};
